import HeaderLogo from "../components/HeaderLogo";
import MarketingSectionSmall from "../components/MarketingSectionSmall";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

import expertiseImg from "../img/hero-carousel/expertise.webp";

import { IconContext } from "react-icons";
import { FaAws } from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { DiBootstrap } from "react-icons/di";
import { SiPostgresql } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { FaReact } from "react-icons/fa";
import { DiNodejsSmall } from "react-icons/di";
import { SiMongodb } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";

const OurExpertise = () => {
  return (
    <>
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex justify-content-between">
          <HeaderLogo />

          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <a className="nav-link scrollto" href="/">
                  Home
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#about">
                  Our Expertise
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#services">
                  Our Technology Stack
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#contact">
                  Connect with Us
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <section id="hero">
        <div
          id="heroCarousel"
          className="carousel slide carousel-fade"
          data-bs-ride="true"
        >
          <div className="carousel-inner">
            <div className="carousel-item active" data-bs-interval="5000">
              <img
                src={expertiseImg}
                className="d-block h-100"
                alt="Trivut's Innovative Solutions"
              />
              <div className="carousel-caption carousel-container">
                <div className="container">
                  <h2 className="animate__animated animate__fadeInDown">
                    Trivut's Innovative Solutions
                  </h2>
                  <p className="animate__animated animate__fadeInUp">
                    Our team of skilled developers utilize the latest
                    technologies and industry best practices to deliver software
                    solutions that meet the highest technical standards
                  </p>
                  <a
                    href="#contact"
                    className="btn-get-started scrollto animate__animated animate__fadeInUp"
                  >
                    Connect with Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <main id="main">
        {/* About Section - Start */}
        <div id="about" className="about-area area-padding">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-headline text-center">
                  <h2>
                    Innovate Your Business with
                    <br /> Our Cutting-Edge Software Solutions
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <p>
                  Introducing our cutting-edge software solution, built to
                  revolutionize the way businesses operate in the digital age.
                  Our cloud-based platform offers unparalleled scalability,
                  flexibility, and reliability to help you achieve your goals
                  faster and more efficiently than ever before.
                </p>
                <p>
                  At the heart of our software solution is our commitment to
                  security. We understand the importance of protecting your data
                  and systems from cyber threats, and that's why we have
                  incorporated the latest security measures into our platform.
                  Our DevSecOps approach ensures that security is built into
                  every stage of the software development process, from design
                  to deployment, providing you with peace of mind that your
                  business is secure.
                </p>
                <p>
                  Our Continuous Integration and Continuous Deployment (CI/CD)
                  pipelines automate the software development process, enabling
                  faster and more frequent releases. This means that you can
                  deliver new features and updates to your customers at
                  lightning speed, keeping you ahead of the competition. With
                  our microservices architecture, we can break down complex
                  software solutions into smaller, independent modules, making
                  it easier to develop, deploy, and maintain.
                </p>
                <p>
                  Our cloud computing infrastructure allows us to provide
                  unparalleled scalability and flexibility to meet the needs of
                  businesses of all sizes. Our cloud-based platform ensures that
                  your software solutions are always available, with automatic
                  scaling and load balancing to handle any spikes in demand.
                  This means that you can focus on running your business, while
                  we take care of the technology.
                </p>
                <p>
                  With our innovative software solution, you can streamline your
                  operations, reduce costs, and increase productivity. Our
                  platform offers a range of tools and features to help you
                  manage your business more efficiently, from project management
                  to customer relationship management. You can even customize
                  our platform to meet the specific needs of your business, with
                  our easy-to-use drag-and-drop interface.
                </p>
                <p>
                  Whether you are a startup looking to build a scalable
                  platform, or an established enterprise seeking to modernize
                  your technology stack, our software solution has got you
                  covered. With our cloud-based platform, you can access your
                  software solutions from anywhere in the world, with no need
                  for expensive hardware or IT infrastructure. This makes our
                  platform ideal for businesses with remote or distributed
                  teams, who need to collaborate and share information in
                  real-time.
                </p>
                <p>
                  Our software solution offers unparalleled security,
                  scalability, and flexibility to help your business thrive in
                  the digital age. With our DevSecOps approach, CI/CD pipelines,
                  microservices architecture, and cloud computing
                  infrastructure, we are redefining the way software solutions
                  are built and deployed. Whether you are a startup or an
                  established enterprise, our platform can help you achieve your
                  goals faster and more efficiently than ever before. So why
                  wait? Contact us today to learn more about our software
                  solution and how we can help your business succeed.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* About Section - End */}

        {/* Technology Stack - Start */}
        <div id="services" className="services-area area-padding">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-headline services-head text-center">
                  <h3>Our Technology Stack</h3>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.9em", color: "#FF9900" }}
                        >
                          <FaAws />
                        </IconContext.Provider>
                      </a>
                      <h4>Amazon Web Services</h4>
                      <p>
                        Amazon Web Services (AWS) is the world's most
                        comprehensive and broadly adopted cloud platform,
                        offering over 200 fully featured services from data
                        centers globally. With Amazon Web Services (AWS), you
                        can innovate faster, reduce costs, and operate more
                        securely, giving you the agility to expand your business
                        and meet customer needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#F0DB4F" }}
                        >
                          <DiJavascript />
                        </IconContext.Provider>
                      </a>
                      <h4>Javascript</h4>
                      <p>
                        JavaScript is the backbone of modern web development,
                        enabling dynamic and interactive user experiences across
                        a wide range of platforms and devices. With its
                        versatility and ease of use, JavaScript has become the
                        most widely used programming language for front-end web
                        development, making it an essential tool for creating
                        engaging web experiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon" href="#">
                        <IconContext.Provider
                          value={{ size: "1.9em", color: "#602C50" }}
                        >
                          <DiBootstrap />
                        </IconContext.Provider>
                      </a>
                      <h4>Bootstrap 5</h4>
                      <p>
                        Bootstrap 5 is a powerful and intuitive front-end
                        framework allowing you to build responsive and
                        mobile-first web applications quickly and easily. With
                        its extensive library of pre-built components and
                        easy-to-use grid system, it is the perfect choice for
                        any web developer looking to streamline their
                        development process and deliver high-quality web
                        experiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#008bb9" }}
                        >
                          <SiPostgresql />
                        </IconContext.Provider>
                      </a>
                      <h4>PostgreSQL </h4>
                      <p>
                        PostgreSQL is a powerful, open-source database system
                        that is highly scalable and reliable, making it the
                        ideal choice for web developers who need to manage
                        complex data sets with ease. With its advanced features
                        and strong community support, PostgreSQL is the smart
                        choice for any web development project.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#000" }}
                        >
                          <SiExpress />
                        </IconContext.Provider>
                      </a>
                      <h4>Express.js</h4>
                      <p>
                        Express.js is a versatile and powerful web framework for
                        Node.js that enables developers to rapidly build web
                        applications and APIs. With its streamlined syntax,
                        modular structure, and extensive middleware ecosystem,
                        Express.js is the ideal choice for creating scalable,
                        secure, and performant web applications that meet your
                        users' needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#61DBFB" }}
                        >
                          <FaReact />
                        </IconContext.Provider>
                      </a>
                      <h4>React.js</h4>
                      <p>
                        React.js is a powerful front-end JavaScript library that
                        enables developers to build complex user interfaces with
                        reusable components. With its efficient rendering engine
                        and declarative programming model, React.js simplifies
                        the development process and allows you to create dynamic
                        and responsive web applications that scale with your
                        business needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#61DBFB" }}
                        >
                          <TbBrandReactNative />
                        </IconContext.Provider>
                      </a>
                      <h4>React Native</h4>
                      <p>
                        React Native is a versatile JavaScript framework that
                        helps build high-quality, native mobile applications for
                        iOS and Android. With its efficient development process
                        and extensive library of pre-built components, React
                        Native is ideal for cross-platform mobile apps that
                        deliver a seamless user experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#68a063" }}
                        >
                          <DiNodejsSmall />
                        </IconContext.Provider>
                      </a>
                      <h4>Node.js </h4>
                      <p>
                        Node.js is a powerful, server-side JavaScript runtime
                        that enables developers to build scalable and
                        high-performing web applications. With its non-blocking
                        I/O model and event-driven architecture, Node.js allows
                        for lightning-fast data processing and makes it easy to
                        build real-time, data-intensive applications.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className=" about-move">
                  <div className="services-details">
                    <div className="single-services">
                      <a className="services-icon">
                        <IconContext.Provider
                          value={{ size: "1.8em", color: "#4DB33D" }}
                        >
                          <SiMongodb />
                        </IconContext.Provider>
                      </a>
                      <h4>MongoDB</h4>
                      <p>
                        MongoDB is a flexible, open-source NoSQL database that
                        allows you to manage large amounts of data quickly and
                        easily. With its scalable architecture, powerful query
                        language, and flexible data model, MongoDB is perfect
                        for building modern, data-driven applications that can
                        grow with your business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Technology Stack - End */}

        {/* Marketing Section - Small */}
        <MarketingSectionSmall />

        {/* Contact Form Section */}
        <ContactForm />
      </main>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default OurExpertise;
